import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import IMG from "../assets/IMG.webp";
import OurBlog from "./Blogs";
import Footer from "./Footer";
import Navbar from "./Navbar";

const Preapproveloan = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      <Navbar />
      <div
        className="container py-md-5 mt-5 mb-5"
        style={{ maxWidth: "1400px" }}
      >
        <div className="preapproved-blur-top-right"></div>
        <div className="preapproved-blur-bottom-left "></div>
        <h1 className="fw-semibold text-center pt-5">Why wait?</h1>
        <p className="text-center fw-semibold mt-3">
          {" "}
          Your Pre-Approved Loan is Just a Click Away!
        </p>

        <div
          className="carding my-3 border-0 mt-5 mx-auto  w-100 shaddow"
          style={{
            maxWidth: "100%",
          }}
        >
          <div className="row g-5 align-items-stretch">
            <div className="col-12 col-md-6  ">
              <div
                className="bg-white p-4 rounded-4h-100 shadow-sm"
                style={{
                  minHeight: "400px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4 className="fw-normal text-start text-black">
                  Pre-Approve Loan
                </h4>
                <p className="text-muted text-start medium">
                  Let's get you started quickly!
                </p>

                <div className="text-start mb-3">
                  <p className="mb-1 medium">Mobile No</p>
                  <input
                    type="tel"
                    placeholder="Enter Mobile Number"
                    className="form-control form-control-medium mb-2"
                  />
                  <p className="mb-1 medium">Pan Card</p>
                  <input
                    type="tel"
                    placeholder="Pan Card Number"
                    className="form-control form-control-medium mb-2"
                  />

                  <div
                    className="text-start mt-3 mb-3"
                    style={{ fontFamily: "popins", cursor: "pointer" }}
                  >
                    <button className="btn bg-primary text-white fw-semibold d-flex align-items-center px-3 py-2 rounded-3 border-0">
                      Submit
                      <i className="fas fa-arrow-right ms-2"></i>
                    </button>
                  </div>

                  <p className="text-muted text-start mb-1 medium">
                    Already Applied?
                  </p>
                  <Link
                    to="/Track"
                    className="text-start text-primary text-decoration-none fs-6"
                  >
                    Track Your Application now
                    <i className="fas fa-arrow-right ms-2"></i>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 ">
              <div
                className="position-relative rounded-4 h-100 overflow-hidden "
                style={{
                  backgroundColor: "#E0FFF9",
                  minHeight: "400px",
                  borderRadius: "50%",
                }}
              >
                <div class="circle-gradient-preapproved"></div>
                <img
                  src={IMG}
                  alt=""
                  className="position-absolute rounded-4"
                  style={{
                    maxHeight: "100%",
                    width: "auto",
                    maxWidth: "75%",
                    objectFit: "contain",
                    objectPosition: "right bottom",
                    bottom: "0",
                    right: "0",
                    zIndex: 1,
                    pointerEvents: "none",
                  }}
                />

                <div
                  className="position-absolute"
                  style={{
                    top: "20px",
                    left: "20px",
                    // zIndex: 0,
                    // color: "#4B4B4B",
                  }}
                >
                  <h5 className="fw-semibold mt-1 preapproved-title">
                    Get pre-approved <br />
                    for your loan in <br />
                    minutes!
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OurBlog />
      <Footer />
    </>
  );
};

export default Preapproveloan;
